'use strict';

/* global $ */

import { Ajax } from '../utils/ajax';

import { FoldingReviews } from '../modules/folding-reviews';


let settings = {
    selector: '.js-show-more',
    linkSelector: '.js-show-more__link',
    navSelector: '.js-nav-block'
};

class AjaxReviews {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ AjaxReviews/init ]');

        let is_send = false;

        let $block = $(this.opt.selector),
            $link = $(this.opt.linkSelector),
            $navBlock = $(this.opt.navSelector);

        $navBlock.hide();
        $block.show();

        $link.on('click', function(e) {
            let $this = $(this);
            e.preventDefault();

            if (!is_send) {
                is_send = true;

                let page = $this.data('page'),
                    per_page = $this.data('per-page'),
                    object_id = $this.data('object-id'),
                    showed = $this.data('showed'),
                    total = $this.data('total'),
                    page_type = $this.data('page-type');
            
                Ajax.get('get_reviews', { page: page, page_type: page_type, reviews_id: object_id }).then((data) => {
                    console.log('Reviews/get/then', data);

                    if (data.ok) {
                        is_send = false;

                        $navBlock.last().before(data.content);
                        showed += per_page;
                        $link.data('page', page + 1);
                        $link.data('showed', showed + per_page);
                        if (total <= showed) {
                            $block.hide();
                        }
                        $(window).trigger('resize');
                        this.foldingReviews = new FoldingReviews();
                    }
                });
            }
        });  
    }
}


export {
    AjaxReviews
};
